@if (hasPresenterRole()) {
  <div>
    @if (activity.have_i_submitted === false) {
      <span class="not-submitted" translate="common_unsubmitted"></span>
    }
    @if (activity.have_i_submitted) {
      <span class="has-submitted">
        @if (isNotGraded()) {
          <span class="not-graded submitted" translate="common_submitted"></span>
        }
        @if (hasNoScores()) {
          <span class="is-unscored" translate="common_unscored">
          </span>
        }
        @if (hasScores()) {
          <span class="is-scored">
            {{ activity.my_score + " / " + activity.total_score }}
          </span>
        }
      </span>
    }
  </div>
}
@if (hasReviewerOrHigherRole()) {
  <div>
    @if (isNotGraded() && activity.usage >= 0) {
      <span
        class="not-graded"
        translate="activity-list-num-submitted"
        [translateParams]="{ number: activity.usage }">
      </span>
    }
    @if (hasSomeGraded()) {
      <span
        class="some-scored"
        translate="activity-list-status_some-scored"
        [translateParams]="{ score: activity.num_graded + ' / ' + activity.usage }"
        >
      </span>
    }
    @if (isAllGraded()) {
      <span>
        <span class="all-scored" translate="activity-list-status_all-scored"></span>
      </span>
    }
  </div>
}
